module.exports = __webpack_public_path__ + "img/HB-Torshavn.ae78c3e9.png";